module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', {
    attrs: {
      "title": "Filtro"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Descrição do Filtro ...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/novo-filtro"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Novo Filtro")])])], 1)])])]), _vm._v(" "), _c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filtros), function(f) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(f.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(f.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.posicao))]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + f.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Filtro',
          params: {
            id: f.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_prod_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluir(f.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderProduto(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d10b0a0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Filtros/Filtros.vue
// module id = 1293
// module chunks = 1